import React from 'react';

const RightFilled: React.FC<
  React.HTMLProps<SVGAElement> & { primary?: boolean }
> = ({ className }) => {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7L-6.52533e-07 13.9282L-4.68497e-08 0.0717964L12 7Z"
        fill="#4A5568"
      />
    </svg>
  );
};

export default RightFilled;
